function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwSearchBox from 'viewmodel/AwSearchBoxViewModel';
import AwList from 'viewmodel/AwListViewModel';
import AwDefaultCell from 'viewmodel/AwDefaultCellViewModel';
import AwIcon from 'viewmodel/AwIconViewModel';
import AwLink from 'viewmodel/AwLinkViewModel';
import AwNavigateBreadcrumb from 'viewmodel/AwNavigateBreadcrumbViewModel';
import { VisibleWhen } from 'js/hocCollection';
const AwFlexColumnVisibleWhen = VisibleWhen(AwFlexColumn);
AwFlexColumnVisibleWhen.displayName = 'AwFlexColumnVisibleWhen';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/projectHelperService', () => import('js/projectHelperService'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "dataProviders": {
    "listProjectContentsDataProvider": {
      "action": "getProjectContents",
      "response": "{{projectContents}}",
      "totalFound": "{{totalCount}}"
    },
    "listProjectsDataProvider": {
      "action": "getProjects",
      "response": "{{projects}}",
      "totalFound": "{{totalCount}}"
    }
  },
  "data": {
    "textValue": {
      "displayName": "",
      "type": "STRING",
      "isRequired": "false",
      "isEditable": "true",
      "dbValue": null,
      "dispValue": ""
    },
    "projectsLink": {
      "displayName": "{{i18n.allProjects}}",
      "type": "STRING",
      "isRequired": "false"
    },
    "selectedProjectId": {
      "displayName": "",
      "type": "STRING",
      "isRequired": "false",
      "isEditable": "true",
      "dbValue": null,
      "dispValue": ""
    },
    "selectedFolderId": {
      "displayName": "",
      "type": "STRING",
      "isRequired": "false",
      "isEditable": "true",
      "dbValue": null,
      "dispValue": ""
    },
    "dynamicCrumbs": [],
    "projectsSkip": 0,
    "projectContentsSkip": 0,
    "bcConfig": {
      "navigationBreadcrumbConfig": {
        "type": "navigate",
        "vm": "navigateBreadcrumblist",
        "chevronDataProvider": "navigationBreadcrumbchevronDataProvider",
        "id": "d_uids",
        "noUpdate": true,
        "displayProperty": "object_string"
      }
    }
  },
  "i18n": {
    "allProjects": ["projectMessages"],
    "projects": ["projectMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "EMPTY_CONTAINER_ID": ["errorMessages"],
    "BAD_REQUEST_GET_PROJECTS": ["errorMessages"],
    "FORBIDDEN_GET_PROJECTS": ["errorMessages"],
    "BAD_REQUEST_GET_PROJECT_CONTENT": ["errorMessages"],
    "FORBIDDEN_GET_PROJECTS_CONTENT": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"]
  },
  "actions": {
    "init": {
      "actionType": "batchJob",
      "steps": [{
        "action": "refreshViewModel"
      }, {
        "action": "loadProjectsDataProvider"
      }]
    },
    "refreshViewModel": {
      "actionType": "JSFunction",
      "method": "refreshViewModel",
      "inputData": {
        "data": "{{data}}"
      },
      "deps": "js/projectHelperService"
    },
    "resetSkipAndLoadProjectsDataProvider": {
      "actionType": "batchJob",
      "steps": [{
        "action": "resetSkipVals"
      }, {
        "action": "loadProjectsDataProvider"
      }]
    },
    "resetSkipAndLoadProjectContentsDataProvider": {
      "actionType": "batchJob",
      "steps": [{
        "action": "resetSkipVals"
      }, {
        "action": "loadProjectContentsDataProvider"
      }]
    },
    "resetSkipVals": {
      "actionType": "JSFunction",
      "method": "resetSkipVals",
      "inputData": {
        "data": "{{data}}"
      },
      "deps": "js/projectHelperService"
    },
    "loadProjectsDataProvider": {
      "actionType": "dataProvider",
      "method": "listProjectsDataProvider"
    },
    "getProjects": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query getProjects( $getProjectsInput: GetProjectsInput ) { getProjects( getProjectsInput: $getProjectsInput) { error items totalCount skip}}",
            "variables": {
              "getProjectsInput": {
                "collaborationspaceId": "{{props.collaborationspaceid}}",
                "skip": "{{data.projectsSkip}}",
                "filterString": "{{data.textValue.dbValue}}",
                "totalCount": "{{data.dataProviders.listProjectsDataProvider.startIndex}}",
                "roleFilters": "{{props.roleFilters}}",
                "ownershipFilters": "{{props.ownershipFilters}}"
              }
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "outputData": {
        "errorCode": "errorCode",
        "getProjects": "data.data.getProjects",
        "projects": "data.data.getProjects.items",
        "projectsSkip": "data.data.getProjects.skip",
        "totalCount": "data.data.getProjects.totalCount"
      },
      "events": {
        "success": [{
          "condition": "getProjects.error === 'EMPTY_COLLAB_SPACE'",
          "name": "getProjects.failure",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "getProjects.error.statusCode === 400 || errorCode === 400",
          "name": "getProjects.failure",
          "eventData": {
            "error": "{{i18n.BAD_REQUEST_GET_PROJECTS}}",
            "errorCode": 400
          }
        }, {
          "condition": "getProjects.error.statusCode === 403 || errorCode === 403",
          "name": "getProjects.failure",
          "eventData": {
            "error": "{{i18n.FORBIDDEN_GET_PROJECTS}}",
            "errorCode": 403
          }
        }, {
          "condition": "getProjects.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "getProjects.failure",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "getProjects.error.statusCode >= 500 && getProjects.error.statusCode <= 599",
          "name": "getProjects.failure",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "getProjects.failure",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "actionMessages": {},
      "deps": "js/accHttpService"
    },
    "loadProjectContentsDataProvider": {
      "actionType": "dataProvider",
      "method": "listProjectContentsDataProvider"
    },
    "getProjectContents": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "query getProjectContents( $projectId: String, $collaborationspaceId: String, $folderId: String, $skip: Int, $filterString: String, $totalCount: Int) { getProjectContents( projectId: $projectId, collaborationspaceId: $collaborationspaceId, folderId: $folderId, skip: $skip, filterString: $filterString, totalCount: $totalCount ) { error items totalCount skip }}",
            "variables": {
              "projectId": "{{data.selectedProjectId.dbValue}}",
              "collaborationspaceId": "{{props.collaborationspaceid}}",
              "folderId": "{{data.selectedFolderId.dbValue}}",
              "filterString": "{{data.textValue.dbValue}}",
              "skip": "{{data.projectContentsSkip}}",
              "totalCount": "{{data.dataProviders.listProjectContentsDataProvider.startIndex}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "outputData": {
        "errorCode": "errorCode",
        "getProjectContents": "data.data.getProjectContents",
        "projectContents": "data.data.getProjectContents.items",
        "projectContentsSkip": "data.data.getProjectContents.skip",
        "totalCount": "data.data.getProjectContents.totalCount"
      },
      "events": {
        "success": [{
          "condition": "getProjectContents.error === 'EMPTY_COLLAB_SPACE'",
          "name": "getProjectContents.failure",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "getProjects.error === 'EMPTY_CONTAINER_ID'",
          "name": "getProjectContents.failure",
          "eventData": {
            "error": "{{i18n.EMPTY_CONTAINER_ID}}",
            "errorCode": 400
          }
        }, {
          "condition": "getProjectContents.error.statusCode === 400 || errorCode === 400",
          "name": "getProjectContents.failure",
          "eventData": {
            "error": "{{i18n.BAD_REQUEST_GET_PROJECT_CONTENT}}",
            "errorCode": 400
          }
        }, {
          "condition": "getProjectContents.error.statusCode === 403 || errorCode === 403",
          "name": "getProjectContents.failure",
          "eventData": {
            "error": "{{i18n.FORBIDDEN_GET_PROJECT_CONTENT}}",
            "errorCode": 403
          }
        }, {
          "condition": "getProjectContents.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "getProjectContents.failure",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "getProjectContents.error.statusCode >= 500 && getProjectContents.error.statusCode <= 599",
          "name": "getProjectContents.failure",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "getProjectContents.failure",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "manageListCellSelection": {
      "actionType": "JSFunction",
      "method": "manageListCellSelection",
      "inputData": {
        "data": "{{data}}",
        "selectedObjects": "{{data.eventData.selectedObjects}}"
      },
      "deps": "js/projectHelperService",
      "events": {
        "success": [{
          "condition": "data.eventData.selectedObjects[0].cellType === 'Project' || data.eventData.selectedObjects[0].cellType === 'Folder'",
          "name": "NavigateProjectContentsAsList.resetAndloadProjectContents"
        }, {
          "condition": "data.eventData.selectedObjects.length !== 0 && (data.eventData.selectedObjects[0].cellType === 'Project' || data.eventData.selectedObjects[0].cellType === 'Folder')",
          "name": "NavigateProjectContentsAsList.projectOrFolderSelected",
          "eventData": {
            "projectOrFolderSelected": "{{data.eventData.selectedObjects[0]}}"
          }
        }, {
          "condition": "data.eventData.selectedObjects.length === 0 || (data.eventData.selectedObjects[0].cellType !== 'Project' && data.eventData.selectedObjects[0].cellType !== 'Folder')",
          "name": "NavigateProjectContentsAsList.partSelected",
          "eventData": {
            "selectedObjects": "{{data.eventData.selectedObjects}}"
          }
        }]
      }
    },
    "resetSkipAndManageCrumbSelection": {
      "actionType": "batchJob",
      "steps": [{
        "action": "resetSkipVals"
      }, {
        "action": "manageCrumbSelection"
      }]
    },
    "manageCrumbSelection": {
      "actionType": "JSFunction",
      "method": "manageCrumbSelection",
      "inputData": {
        "data": "{{data}}",
        "crumbIndex": "{{data.eventData.crumbIndex}}"
      },
      "deps": "js/projectHelperService",
      "events": {
        "success": [{
          "name": "NavigateProjectContentsAsList.resetAndloadProjectContents"
        }]
      }
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    }
  },
  "conditions": {
    "isBreadCrumbEnabled": {
      "expression": "data.selectedProjectId.dbValue !== null"
    },
    "validInput": {
      "expression": "props.accsessionid && props.accsessionid.length > 0 && props.collaborationspaceid && props.collaborationspaceid.length > 0"
    }
  },
  "lifecycleHooks": {
    "onMount": "",
    "onUpdate": [{
      "action": "init",
      "observers": ["props.accsessionid", "props.collaborationspaceid"]
    }]
  },
  "onEvent": [{
    "eventId": "listProjectsDataProvider.selectionChangeEvent",
    "action": "manageListCellSelection",
    "cacheEventData": true
  }, {
    "eventId": "listProjectContentsDataProvider.selectionChangeEvent",
    "action": "manageListCellSelection",
    "cacheEventData": true
  }, {
    "eventId": "NavigateProjectContentsAsList.resetAndloadProjects",
    "action": "resetSkipAndLoadProjectsDataProvider"
  }, {
    "eventId": "NavigateProjectContentsAsList.resetAndloadProjectContents",
    "action": "resetSkipAndLoadProjectContentsDataProvider"
  }, {
    "eventId": "NavigateProjectContentsAsList.breadCrumbSelected",
    "action": "resetSkipAndManageCrumbSelection",
    "cacheEventData": true
  }, {
    "eventId": "NavigateProjectContentsAsList.breadCrumbSelected",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-navigate-project-contents-as-list.partSelected",
      "eventData": "{{eventData.crumb}}"
    }
  }, {
    "eventId": "NavigateProjectContentsAsList.breadCrumbSelected",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-navigate-project-contents-as-list.part-selected",
      "eventData": "{{eventData.crumb}}"
    }
  }, {
    "eventId": "NavigateProjectContentsAsList.projectOrFolderSelected",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-navigate-project-contents-as-list.partSelected",
      "eventData": "{{eventData.projectOrFolderSelected}}"
    }
  }, {
    "eventId": "NavigateProjectContentsAsList.projectOrFolderSelected",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-navigate-project-contents-as-list.part-selected",
      "eventData": "{{eventData.projectOrFolderSelected}}"
    }
  }, {
    "eventId": "NavigateProjectContentsAsList.partSelected",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-navigate-project-contents-as-list.partSelected",
      "eventData": "{{eventData.selectedObjects}}"
    }
  }, {
    "eventId": "NavigateProjectContentsAsList.partSelected",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-navigate-project-contents-as-list.part-selected",
      "eventData": "{{eventData.selectedObjects}}"
    }
  }, {
    "eventId": "getProjects.failure",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-navigate-project-contents-as-list.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }, {
    "eventId": "getProjectContents.failure",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-navigate-project-contents-as-list.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }],
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "role-filters": {
      "type": "string"
    },
    "ownership-filters": {
      "type": "string"
    }
  },
  "_viewModelId": "NavigateProjectContentsAsList",
  "_uniqueViewModelId": "NavigateProjectContentsAsList",
  "ctx": {}
};

/*
<div class="afx-content-background aw-layout-full">
    <aw-flex-column width="fill" visible-when="!conditions.isBreadCrumbEnabled" class="aw-layout-full">
        <aw-flex-row height="4f" class="aw-widgets-cellListCellTitleBlock">
            <span class="aw-widgets-cellListCellTitle">{{i18n.projects}}</span>
        </aw-flex-row>
        <aw-flex-row height="3.5f">
            <aw-flex-column width="fill">
                <aw-search-box prop="textValue" placeholder="Search" action="resetSkipAndLoadProjectsDataProvider"></aw-search-box>
            </aw-flex-column>
        </aw-flex-row>
        <aw-list dataprovider="dataProviders.listProjectsDataProvider" hasFloatingCellCommands="false">
            <aw-default-cell vmo="item"></aw-default-cell>
        </aw-list>
    </aw-flex-column>
    <aw-flex-column width="fill" visible-when="conditions.isBreadCrumbEnabled" class="aw-layout-full">
        <aw-flex-row height="1.5f">
            <aw-flex-column width="1f" class="aw-layout-fxbreadCrumbs">
                <aw-icon icon-id="miscChevronLeftDouble" class="sw-button-icon"></aw-icon>
            </aw-flex-column>
            <aw-link action="init" prop="data.projectsLink"></aw-link>
        </aw-flex-row>
        <aw-flex-row height="3.5f">
            <aw-navigate-breadcrumb crumbs="data.dynamicCrumbs" breadcrumb-config ="data.bcConfig.navigationBreadcrumbConfig" popupList="NavigateBreadcrumblist"></aw-navigate-breadcrumb>
        </aw-flex-row>
        <aw-flex-row height="3.5f">
            <aw-flex-column width="fill">
                <aw-search-box prop="textValue" placeholder="Search" action="resetSkipAndLoadProjectContentsDataProvider"></aw-search-box>
            </aw-flex-column>
        </aw-flex-row>
        <aw-list dataprovider="dataProviders.listProjectContentsDataProvider" hasFloatingCellCommands="false">
            <aw-default-cell vmo="item"></aw-default-cell>
        </aw-list>
    </aw-flex-column>
</div>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "afx-content-background aw-layout-full"
  }, /*#__PURE__*/React.createElement(AwFlexColumnVisibleWhen, {
    width: "fill",
    className: "aw-layout-full",
    visibleWhen: AwParseService.instance("!conditions.isBreadCrumbEnabled")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(AwFlexRow, {
    height: "4f",
    className: "aw-widgets-cellListCellTitleBlock"
  }, /*#__PURE__*/React.createElement("span", {
    className: "aw-widgets-cellListCellTitle"
  }, AwParseService.instance("i18n.projects")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  }))), /*#__PURE__*/React.createElement(AwFlexRow, {
    height: "3.5f"
  }, /*#__PURE__*/React.createElement(AwFlexColumn, {
    width: "fill"
  }, /*#__PURE__*/React.createElement(AwSearchBox, _extends({}, getField("textValue", fields, $index, null, null), {
    placeholder: AwParseService.instance("Search")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    action: actions.resetSkipAndLoadProjectsDataProvider
  })))), /*#__PURE__*/React.createElement(AwList, {
    dataprovider: dataProviders.listProjectsDataProvider,
    showDropArea: null,
    dndHandler: props.viewModel.dndHandler,
    hasfloatingcellcommands: "false"
  }, ({
    item,
    index
  }) => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "                ", /*#__PURE__*/React.createElement(AwDefaultCell, {
      vmo: AwParseService.instance("item")({
        props,
        data,
        fields,
        dataProviders,
        ctx,
        i18n,
        actions,
        subPanelContext,
        viewPath,
        conditions,
        formProp,
        dispatch,
        selectionModels,
        editHandlers,
        chartProviders,
        ports,
        item,
        index
      })
    }));
  })), /*#__PURE__*/React.createElement(AwFlexColumnVisibleWhen, {
    width: "fill",
    className: "aw-layout-full",
    visibleWhen: AwParseService.instance("conditions.isBreadCrumbEnabled")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(AwFlexRow, {
    height: "1.5f"
  }, /*#__PURE__*/React.createElement(AwFlexColumn, {
    width: "1f",
    className: "aw-layout-fxbreadCrumbs"
  }, /*#__PURE__*/React.createElement(AwIcon, {
    iconId: "miscChevronLeftDouble",
    className: "sw-button-icon"
  })), /*#__PURE__*/React.createElement(AwLink, _extends({
    action: actions.init
  }, getField("data.projectsLink", fields, $index, null, null)))), /*#__PURE__*/React.createElement(AwFlexRow, {
    height: "3.5f"
  }, /*#__PURE__*/React.createElement(AwNavigateBreadcrumb, {
    crumbs: AwParseService.instance("data.dynamicCrumbs")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "breadcrumb-config": "data.bcConfig.navigationBreadcrumbConfig",
    popuplist: "NavigateBreadcrumblist"
  })), /*#__PURE__*/React.createElement(AwFlexRow, {
    height: "3.5f"
  }, /*#__PURE__*/React.createElement(AwFlexColumn, {
    width: "fill"
  }, /*#__PURE__*/React.createElement(AwSearchBox, _extends({}, getField("textValue", fields, $index, null, null), {
    placeholder: AwParseService.instance("Search")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    action: actions.resetSkipAndLoadProjectContentsDataProvider
  })))), /*#__PURE__*/React.createElement(AwList, {
    dataprovider: dataProviders.listProjectContentsDataProvider,
    showDropArea: null,
    dndHandler: props.viewModel.dndHandler,
    hasfloatingcellcommands: "false"
  }, ({
    item,
    index
  }) => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "                ", /*#__PURE__*/React.createElement(AwDefaultCell, {
      vmo: AwParseService.instance("item")({
        props,
        data,
        fields,
        dataProviders,
        ctx,
        i18n,
        actions,
        subPanelContext,
        viewPath,
        conditions,
        formProp,
        dispatch,
        selectionModels,
        editHandlers,
        chartProviders,
        ports,
        item,
        index
      })
    }));
  })));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;